import { render } from "./CurrentEmployee.vue?vue&type=template&id=79d134b2&scoped=true"
import script from "./CurrentEmployee.vue?vue&type=script&lang=js"
export * from "./CurrentEmployee.vue?vue&type=script&lang=js"

import "./CurrentEmployee.vue?vue&type=style&index=0&id=79d134b2&scoped=true&lang=css"

import exportComponent from "/root/fixed-links/crm-updated/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79d134b2"]])

export default __exports__